module.exports = __webpack_public_path__ + "img/security.c6d3928.svg";